import React, { ReactNode, useState } from 'react';
import Cookies from 'universal-cookie';

import { IPageContext } from 'common/interfaces/pagecontext.interface';

import Footer from '../footer/Footer';
import CookiesAgreement from '../../../privacy-notice/components/CookiesAgreement';
import PreloadEssentials from '../preload-essentials/PreloadEssentials';

interface Props {
  children?: ReactNode;
  layoutClass?: string;
  className?: string;
  privacyCookiesConsent?: boolean;
  pageContext: IPageContext;
}

export const cookiesInitialConsent = 'Cookies consent to all at once';

const Layout = ({
  children,
  layoutClass = 'primary-scheme',
  className = '',
  pageContext,
  privacyCookiesConsent = true,
}: Props) => {
  const [activeAll, setActiveAll] = useState(false);

  const cookies = new Cookies();
  const nextYearDate = new Date();

  nextYearDate.setFullYear(new Date().getFullYear() + 1);

  if (activeAll) {
    const cookieParameters = { path: '/', expires: nextYearDate, sameSite: true };

    cookies.set(cookiesInitialConsent, 'true', cookieParameters);
  }

  return (
    <div className={layoutClass}>
      <PreloadEssentials />

      <main role="main" className={className}>
        {children}
      </main>
      {privacyCookiesConsent && (
        <CookiesAgreement toggleToggles={() => setActiveAll(!activeAll)} pageContext={pageContext} />
      )}
      <Footer pageContext={pageContext} />
    </div>
  );
};

export default Layout;
